import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { ACCOUNT_TABS, getAccountTabPath } from '../../constants/accountTabs';

const AccountSidebar = ({ activeTab }) => {
  const navigate = useNavigate();

  const handleSelect = (tabId) => {
    navigate(getAccountTabPath(tabId), { replace: true });
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        width: { xs: '100%', md: 240 },
        flexShrink: 0,
        alignSelf: 'flex-start',
      }}
    >
      <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle2" color="text.secondary">
          My Account
        </Typography>
      </Box>
      <List disablePadding>
        {ACCOUNT_TABS.map((tab) => {
          const Icon = tab.icon;
          const selected = activeTab === tab.id;
          return (
            <ListItem key={tab.id} disablePadding>
              <ListItemButton
                selected={selected}
                onClick={() => handleSelect(tab.id)}
                sx={{
                  py: 1.25,
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: '#fff',
                    '&:hover': { bgcolor: 'primary.dark' },
                    '& .MuiListItemIcon-root': { color: '#fff' },
                    '& .MuiListItemText-primary': { color: '#fff' },
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Icon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={tab.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default AccountSidebar;
